<template>
  <div>
    <v-app-bar app elevation="0" color="#F2F2F2" dark>
      <!-- :src="require('@/assets/images/background_post.png')" -->

      <font-awesome-icon
        v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
        @click="toggleDrawer"
        class="primary--text font-weight-bold mr-2"
        :icon="['fas', 'bars']"
      ></font-awesome-icon>
      <!-- :src="require('../../assets/images/logoWhite.png')" -->
      <!-- <img :src="require('@/assets/logoBlue.png')" height="35" class="ms-3" /> -->
      <v-spacer></v-spacer>
      <div v-if="!$vuetify.breakpoint.xs" class="mx-1 d-flex align-center">
        <TranslateDialog />
      </div>
      <NotificationMenu />
      <v-menu bottom nudge-bottom="27" left>
        <template #activator="{ on, attrs }">
          <v-btn v-bind="attrs" rounded color="primary" small v-on="on">
            <v-icon>
              mdi-account
            </v-icon>
            <span>{{ $t("common.admin") }}</span>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item class="px-5" @click="adminActionHandler('profile')">
              <v-icon color="primary" left>
                mdi-account
              </v-icon>
              <span>{{ $t("common.profile") }}</span>
            </v-list-item>
            <signout-button />
          </v-list>
        </v-card>
      </v-menu>
      <!-- <template v-slot:extension v-if="$vuetify.breakpoint.xs">
        <v-row justify="center">
          <v-btn-toggle tile group color="#FFFFFF" v-model="tab" mandatory>
          </v-btn-toggle>
        </v-row>
      </template> -->
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawerState"
      app
      v-bind:width="250"
      color="primary"
      :right="$vuetify.rtl"
      elevation="0"
      enable-resize-watcher
      fixed
      class="full-height"
      :mini-variant="miniVariant"
      @update:mini-variant="miniVariant = $event"
    >
      <v-row
        class="tw-cursor-pointer"
        align="center"
        :class="miniVariant ? 'tw-px-0 tw-justify-center' : 'tw-px-3'"
      >
        <v-col
          cols="12"
          v-if="miniVariant"
          class="tw-flex tw-justify-center transition-all duration-300"
        >
          <img
            @click="toggleDrawer"
            src="@/assets/logonew.svg"
            class="tw-min-w-8 tw-w-8 transition-all duration-300"
          />
        </v-col>
        <v-col cols="8" v-if="!miniVariant" class="transition-all duration-300">
          <img
            @click="toggleDrawer"
            src="@/assets/logonewfull.svg"
            class="tw-min-w-32 tw-w-32 transition-all duration-300"
          />
        </v-col>
      </v-row>
      <!-- <v-avatar class="custom-img" size="100">
            <img
              :src="require('../../assets/user.jpg')"
              alt="John"
            >
          </v-avatar> -->

      <!-- <v-card-actions>
          <v-spacer></v-spacer>
            <label class="mt-5 custom-font">
              {{
                role === 'Admin' ?
                $t('common.administrator') : role
              }}
            </label>
          <v-spacer></v-spacer>
        </v-card-actions> -->

      <!-- <div class="custom-line">
      </div> -->
      <v-list dense>
        <span v-for="item in accessableItems" :key="item.title">
          <v-list-item link :to="{ path: item.route }">
            <v-list-item-content>
              <v-list-item-title>
                <v-row align="center">
                  <v-col cols="2">
                    <!-- <v-icon
                      :color="$route.path === item.route ? 'white' : ''"
                      v-text="`mdi-${item.icon}`"
                    ></v-icon> -->
                    <v-icon color="white" v-text="`mdi-${item.icon}`"></v-icon>
                  </v-col>
                  <v-col cols="8" v-if="!miniVariant">
                    <span
                      :class="$route.path === item.route ? 'white--text' : ''"
                    >
                      {{ $t(item.text) }}
                    </span>
                  </v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </span>
      </v-list>
    </v-navigation-drawer>
    <v-row justify="center"> </v-row>
  </div>
</template>

<script>
import SignOutButton from "../../user/components/SignOutButton";
// import UserAvatar from "../../user/components/UserAvatar";
import menuList from "./menu";
import { isAdmin } from "../../user/methods/helper.js";
export default {
  components: {
    "signout-button": SignOutButton,
    TranslateDialog: () => import("@/core/components/TranslateDialog.vue"),
    NotificationMenu: () => import("@/core/components/NotificationsMenu.vue")
    // UserAvatar
  },

  created() {
    const menuLists = this.$format.cloneVariable(menuList);
    if (isAdmin()) {
      this.role = "Admin";
      this.accessableItems = menuLists;
    }
  },
  methods: {
    adminActionHandler(data) {
      switch (data) {
        case "profile":
          this.$root.$emit("openAdminProfile");
      }
    },
    toggleDrawer() {
      if (this.drawerState && !this.miniVariant) {
        this.miniVariant = true;
      } else if (this.drawerState && this.miniVariant) {
        this.miniVariant = false;
      } else {
        this.drawerState = true;
        this.miniVariant = false;
      }
      this.$store.commit("DRAWER_STATE", this.drawerState);
    }
  },
  mounted() {
    if (localStorage.getItem("RENTAL_APP_LANG"))
      this.$i18n.locale = localStorage.getItem("RENTAL_APP_LANG");
  },
  data() {
    return {
      drawerState: true,
      miniVariant: false,
      role: "",
      firstName: "",
      lastName: "",
      accessableItems: [],
      langSwitchDialog: false,
      langSwitchBtn: false
    };
  }
};
</script>
<style scoped>
.theme--light.v-btn--active:hover::before,
.theme--light.v-btn--active::before {
  opacity: 1 !important;
  border-radius: 10px;
  background-color: #6fbf98;
}
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 1 !important;
  /* border-radius: 10px; */
}

.v-list-item--dense .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list--dense .v-list-item .v-list-item__subtitle {
  z-index: 1 !important;
}

svg:not(:root).svg-inline--fa {
  z-index: 1 !important;
}
.v-list-item__title span {
  color: #fff !important;
}
</style>
<style scoped>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 1 !important;
}
.pp {
  font-size: 0.8125rem !important;
  font-weight: 900 !important;
}
/* .custom-img {
  width: 60px;
  height: 60px;
  left: 18px;
  top: 28px;
}
.custom-line {
  width: 165px;
  height: 20px;
  left: 1px;
  top: 176px;
  opacity: 0.1;
  border-bottom: 1px solid #002539;

} */
.v-list .v-list-item--active {
  color: #3391ff;
}
.custom-list {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
}

.v-navigation-drawer__content {
  height: max-content;
  overflow-y: auto;
  overflow-x: hidden;
}
.v-list-item--dense,
.v-list--dense .v-list-item {
  max-height: 43px;
}
</style>
